import { deleteQueryParamsInUrl, responseValidator } from "helpers";
import { API, apiCaller } from "../../services";
import store from "../store";
import { authToken } from "./user.actions";
import { setFactor, setUserInfo, setVoucherToken } from "../slices/userSlice";
import { getLiveAndVodDetails } from "./videoData.actions";
import { setLoginPopover, setPreFactorPopover } from "../slices/popoversSlice";
import { setCinemaHamrahState, setGetDetailsFromVoucher, setPlayerParams } from "../slices/videoDataSlice";
import { CinemaHamrahState } from "interfaces";
import { toast } from "mobin-toast";

export const checkIsFreeContent = async () => {
    const { status } = await apiCaller({url: API().cinemahamrah.checkFreeContent()});
    if(responseValidator(status)) return true;
    else return false;
}

export const checkMciVoucherToken = async () => {
    const dispatch = store.dispatch;
    const { data, status } = await apiCaller({url: API().cinemahamrah.mciVoucherToken()});
    if(responseValidator(status)) {
        dispatch(setVoucherToken(data.jwt));
        return "hasPlan";
    } else if(status === 403) {
        return "NoMCI";
    } else {
        return "hasNoPlan"
    }
}

export const handleCinemaHamrahStates = async () => {
    const dispatch = store.dispatch;
    const result = await checkMciVoucherToken();
    if(result === "hasPlan") {
      dispatch(setCinemaHamrahState(CinemaHamrahState.hasPlan));
      dispatch(setGetDetailsFromVoucher(false));
      getLiveAndVodDetails();
    } else if (result === "hasNoPlan") {
      dispatch(setCinemaHamrahState(CinemaHamrahState.hasNoPlan));
    } else {
      handleNonMCILogin();
    }
}

export const handleNonMCILogin = async () => {
    const dispatch = store.dispatch;
    const authTokenValue = authToken.get();
    if (authTokenValue?.access) {
      const response = await apiCaller({ url: API().cinemahamrah.getProfile(), headers: { "authorization": `Bearer ${authTokenValue.access}` } });
      if (response && responseValidator(response.status)) {
        const userInfo = {
            avatar_url: response.data.picture_url,
            name: response.data.name,
            phone_number: response.data.phone,
            userId: response.data.id,
            isLogin: true,
        }
        dispatch(setUserInfo(userInfo));
        handleUserValidVouchersList();
      } else {
        dispatch(setLoginPopover(true));
      }
    } else dispatch(setLoginPopover(true));
}

export const handleUserValidVouchersList = async () => {
    const dispatch = store.dispatch;
    let { data, status } = await apiCaller({ url: API().cinemahamrah.userValidVouchersList(), headers: {"authorization": `Bearer ${authToken.get()?.access}`} });
    if(responseValidator(status) && data.results.length) handlePubVoucherToken(data.results[0].voucher_id);
    else dispatch(setPreFactorPopover(true));
}

export const handlePubVoucherToken = async (voucherId: string) => {
    const dispatch = store.dispatch;
    const { data, status } = await apiCaller({url: API().cinemahamrah.pubVoucherToken(voucherId)});
    if(responseValidator(status)) {
      dispatch(setGetDetailsFromVoucher(false));
      dispatch(setVoucherToken(data.jwt));
      getLiveAndVodDetails();
    } else dispatch(setPreFactorPopover(true));
}

export const handlePaymentRequest = async (vpId:number, setIsLoading: (isLoading: boolean) => void) => {
    const { params } = store.getState().videoData;
    setIsLoading(true);
    const { data, status } = await apiCaller({ url: API().cinemahamrah.paymentRequest(vpId, +String(params.uid)), headers:{"authorization":`Bearer ${authToken.get()?.access}`}});
    if (responseValidator(status)) window.location.href = data.ipg_url;
    else toast({title: "اتصال به درگاه پرداخت با خطا مواجه شد. لطفا دوباره تلاش کنید.", type: "error"});
    setIsLoading(false);
}

export const handleConfirmPayment = async () => {
    const dispatch = store.dispatch;
    const { params } = store.getState().videoData;
    const { data, status } = await apiCaller({ url: API().cinemahamrah.confirmPayment(), data: {tid: params.transaction_id}, headers: { "authorization": `Bearer ${authToken.get()?.access}` } });
    if(responseValidator(status)) dispatch(setFactor(data));
}

export const handlePlayVideoInFactor = () => {
    const dispatch = store.dispatch;
    const { params } = store.getState().videoData
    const { factor } = store.getState().user;
    deleteQueryParamsInUrl("transaction_id");
    handlePubVoucherToken(factor?.voucher_id!);
    dispatch(setPlayerParams({ ...params, transaction_id: undefined }))
}

export const handleRetryPayment = () => {
    const dispatch = store.dispatch;
    const {params} = store.getState().videoData
    deleteQueryParamsInUrl("transaction_id");
    dispatch(setPlayerParams({ ...params, transaction_id: undefined }))
    handleNonMCILogin();
}